import React from 'react';

import { Card, CardContent } from '@/components/Common/Card';
import DocumentTemplatesSection from '@/components/Templates/DocumentTemplatesSection';
import InterviewTemplatesSection from '@/components/Templates/InterviewTemplatesSection';

/**
 * Organization "Templates" tab: document templates on top, interview templates below.
 * Each section is a table with its own "new template" modal.
 */
export const OrganizationTemplates: React.FC = () => {
  return (
    <div className="space-y-6">
      <Card>
        <CardContent className="pt-6">
          <DocumentTemplatesSection />
        </CardContent>
      </Card>
      <Card>
        <CardContent className="pt-6">
          <InterviewTemplatesSection />
        </CardContent>
      </Card>
    </div>
  );
};
